export function arrayMove<T>(array: T[], fromIndex: number, toIndex: number): T[] {
  const result = [...array];
  const removed = result.splice(fromIndex, 1)[0];
  if (removed !== undefined) {
    result.splice(toIndex, 0, removed);
  }
  return result;
}
